import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchCountryWiseExperts } from "redux/actions/expertsCountry";

export interface IExpertsCountry {
  selectedCountry: any;
  expertsList: any;
  loading: boolean;
}
const initial: IExpertsCountry = {
  selectedCountry: null,
  expertsList: null,
  loading: false,
};

export const expertsCountrySlice = createSlice({
  name: "expertsCountry",
  initialState: initial,
  reducers: {
    setSelectedCountry: (state, action: PayloadAction<Array<any>>) => {
      state.selectedCountry = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCountryWiseExperts.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchCountryWiseExperts.fulfilled, (state, action) => {
      state.loading = false;
      state.expertsList = action.payload;
    });
    builder.addCase(fetchCountryWiseExperts.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const { setSelectedCountry } = expertsCountrySlice.actions;

export default expertsCountrySlice.reducer;
